// The allergen gate before a basket is placed on a pilot restaurant: what changed or can't be ordered, the allergy
// question, then the restaurant's declared allergens in words with its cross-contact warning. "Confirm" is enabled
// only when the check waits for nothing but the customer's confirmation of exactly this quote.
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { blockedReason, readyToConfirm } from './basketCheck';
import './AllergenGate.css';

export default class AllergenGate extends Component {
  state = { allergyText: '' };

  onAllergySubmit = event => {
    event.preventDefault();
    const text = this.state.allergyText.trim();
    if (text) this.props.onAnswer({ text });
  };

  render() {
    const { check, busy, error, onAnswer, onConfirm, onClose } = this.props;
    if (!check) return null;
    const notices = [...(check.problems || []), ...(check.changes || [])];
    const answered = !check.allergyQuestion;
    const advice = check.advice || {};
    const ready = readyToConfirm(check);
    const reason = blockedReason(check);
    // On the page itself, not inside the basket: on a phone "Chat with us" closes the basket while support is open.
    return ReactDOM.createPortal(
      <div className="lt-allergen-gate" role="dialog" aria-modal="true" aria-labelledby="lt-allergen-gate-title">
        <div className="lt-allergen-gate__dialog">
          <h2 id="lt-allergen-gate-title" className="lt-allergen-gate__title">
            Before you confirm your order
          </h2>
          {notices.length > 0 && (
            <ul className="lt-allergen-gate__notices" aria-label="What changed">
              {notices.map((notice, index) => (
                <li key={`${notice.code}-${index}`}>{notice.message}</li>
              ))}
            </ul>
          )}
          {!answered && (
            <div className="lt-allergen-gate__question">
              <p>{check.allergyQuestion}</p>
              <button
                type="button"
                className="lt-allergen-gate__secondary"
                disabled={busy}
                onClick={() => onAnswer({ none: true })}
              >
                No allergies or dietary requirements
              </button>
              <form onSubmit={this.onAllergySubmit} className="lt-allergen-gate__form">
                <label htmlFor="lt-allergen-gate-text">My allergies or dietary requirements</label>
                <input
                  id="lt-allergen-gate-text"
                  type="text"
                  value={this.state.allergyText}
                  placeholder="For example: milk, nuts, coeliac, vegan"
                  onChange={event => this.setState({ allergyText: event.target.value })}
                />
                <button type="submit" className="lt-allergen-gate__secondary" disabled={busy}>
                  Save
                </button>
              </form>
            </div>
          )}
          {answered && advice.text && (
            <div className="lt-allergen-gate__advice" aria-label="Allergen information">
              {(advice.lines || []).map(line => (
                <p
                  key={line.productId}
                  className={
                    line.needsRestaurantConfirmation ? 'lt-allergen-gate__line--hold' : undefined
                  }
                >
                  {line.text}
                </p>
              ))}
              <p>{advice.crossContact}</p>
              <p className="lt-allergen-gate__small">
                This is the restaurant's declaration, not a guarantee.
                {check.alterationsPolicy ? ' This restaurant does not make alterations.' : ''}
              </p>
              <button
                type="button"
                className="lt-allergen-gate__link"
                disabled={busy}
                onClick={() => onAnswer(null)}
              >
                Change my allergy answer
              </button>
            </div>
          )}
          {reason && !ready && answered && <p className="lt-allergen-gate__reason">{reason}</p>}
          {error && <p className="lt-allergen-gate__reason" role="alert">{error}</p>}
          <div className="lt-allergen-gate__actions">
            <button
              type="button"
              className="lt-allergen-gate__primary"
              disabled={!ready || busy}
              onClick={onConfirm}
            >
              {busy ? 'Checking…' : 'I have read this. Confirm order'}
            </button>
            <button type="button" className="lt-allergen-gate__secondary" disabled={busy} onClick={onClose}>
              Back to basket
            </button>
          </div>
        </div>
      </div>,
      document.body
    );
  }
}



// WEBPACK FOOTER //
// ./src/support/AllergenGate.js